
import { useEffect } from 'react'; 
import { Menubar } from 'primereact/menubar';
import { MenuItem } from 'primereact/menuitem';
import { useNavigate, useParams } from 'react-router-dom';
import { InspectionGradeInfo } from '../components/Inspection/InspectionGradeInfo';
import { useAppSelector, useAppDispatch } from '../hooks/storeHooks';
import { selectInspection } from '../store/selectors/inspectionSelectors';
import { fetchInspectionData } from '../store/thunks/inspectionThunks';
import checklistReviewIcon from '../assets/checklistReview.svg';

export default function Home() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { inspectionId } = useParams();
    const { inspection, loading } = useAppSelector(selectInspection);
    
    useEffect(() => {
        if (inspectionId && !inspection) {
            dispatch(fetchInspectionData(inspectionId));
        }
    }, [inspectionId, inspection]);
    
    const items: MenuItem[] = [
        {
            label: 'Inspection Defects Editor',
            icon: 'pi pi-exclamation-triangle',
            command: () => navigate(`/inspection/${inspectionId}/defects`)
        },
        {
            label: 'Adjusted Grade Editor',
            icon: 'pi pi-sliders-h',
            command: () => navigate(`/inspection/${inspectionId}/adjusted`)
        },
        {
            label: 'Grading',
            icon: 'pi pi-star',
            command: () => navigate(`/inspection/${inspectionId}/grading`)
        },
        {
            label: 'AI Summary',
            icon: 'pi pi-file-edit',
            command: () => navigate(`/inspection/${inspectionId}/ai-summary`)
        },
        ...(inspection ? [{
            label: 'Checklist Review',
            icon: <img src={checklistReviewIcon} alt="Checklist Review" className="icon-checklist-review-menubar" />,
            command: () => navigate(`/inspection/answers/${inspectionId}`)
        }] : [])
    ];

    if (loading) {
        return <div>Loading...</div>;
    }
    
    return (
        <div className="card">
            <div id="technical-review-app-home-header">
                <div id="technical-review-app-home-header-title" className="flex align-items-center justify-content-between mb-4 ml-2">
                    <h2>Technical Review App</h2>
                </div>
            </div>
            <Menubar model={items} />
            <InspectionGradeInfo />
        </div>
    )
}


